var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3098_9248)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412 384.728C296.5 432.5 369.667 595.152 203.167 692.97C137.9 731.314 63.3258 721.932 0 694.717V1024H1440V0.0400391H967C952.003 38.581 947.704 80.5666 956.667 122.552C986.167 260.749 834.5 443.874 705.5 432.5C576.5 421.126 553.147 326.349 412 384.728Z",
    fill: "#ECF6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.154 881.5C531.68 870.126 498.647 775.349 298.99 833.729C192.408 864.893 199.403 944.949 151.758 1024H1440V278.895C1434.95 279.166 1429.85 279.469 1424.72 279.803C1189.2 295.159 1112 336.5 1069.44 571.552C1043.71 713.602 896.628 892.874 714.154 881.5Z",
    fill: "#CCE3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3098_9248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBackground);
export default __webpack_public_path__ + "static/media/MainBackground.a86dd576d6f0468dc9e8b89d466ea38d.svg";
export { ForwardRef as ReactComponent };